import React from "react";
import { CONTACT, SITE_URL, AREA_SERVED } from "../../lib/contact";
import { FAQS } from "../../constants/faq";

// Lista de servicios (debe reflejar los títulos usados en Services.jsx).
// Si agregas/quitas un servicio ahí, actualízalo aquí también.
const SERVICE_NAMES = [
  "Avalúos Comerciales",
  "Avalúos Inmobiliarios",
  "Justipreciación de Rentas",
  "Peritajes Técnicos",
  "Dictámenes Técnicos",
  "Dirección Responsable de Obra (DRO)",
  "Regularización de Inmuebles",
  "Licencias y Trámites",
  "Supervisión de Obra",
  "Consultoría Técnica",
];

function buildLocalBusinessSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": `${SITE_URL}/#negocio`,
    name: CONTACT.firmName,
    founder: {
      "@type": "Person",
      name: CONTACT.founder,
    },
    description:
      "Despacho de valuación inmobiliaria, peritajes técnicos y Dirección Responsable de Obra (DRO) en Puebla, con más de 40 años de experiencia.",
    url: SITE_URL,
    telephone: CONTACT.phoneIntl,
    email: CONTACT.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: CONTACT.address,
      addressLocality: "Puebla",
      addressRegion: "Puebla",
      addressCountry: "MX",
    },
    areaServed: AREA_SERVED.map((city) => ({
      "@type": "City",
      name: city,
    })),
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "09:00",
        closes: "18:00",
      },
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Saturday"],
        opens: "09:00",
        closes: "13:00",
      },
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Servicios",
      itemListElement: SERVICE_NAMES.map((name) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name,
        },
      })),
    },
  };
}

function buildFaqSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.a,
      },
    })),
  };
}

// Inyecta los <script type="application/ld+json"> que Google usa para
// entender el negocio (ficha local) y para mostrar las FAQ como resultado
// enriquecido. No renderiza nada visible.
export default function StructuredData() {
  const localBusiness = buildLocalBusinessSchema();
  const faqPage = buildFaqSchema();

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusiness) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPage) }}
      />
    </>
  );
}
